
import { createContext } from 'react';

export const UserInfo = createContext(null);
export const Organizations = createContext(null);
export const Messages = createContext(null);
export const Audio = createContext(null);
export const Notifications = createContext(null);

